import { CustomToast } from "@/components/custom/custom-toast";
import { createElement } from "react";
import { toast } from "sonner";

interface ShowToastOptions {
  variant: "success" | "error" | "warning";
  title: string;
  description?: string;
}

export function showToast(options: ShowToastOptions) {
  const { variant, title, description } = options;
  return toast.custom(
    (id) =>
      createElement(CustomToast, {
        id,
        variant,
        title,
        ...(description !== undefined && { description }),
      }),
    {
      duration: variant === "success" ? 7000 : Infinity,
      unstyled: true,
    },
  );
}
